import { gql } from 'apollo-angular';

import { CONFIGURATION_VARIABLE_FRAGMENT } from './configuration-variable';

export const PRODUCT_LINE_VARIABLE_FRAGMENT = gql`
  fragment ProductLineVariableFragment on ProductLine {
    id
    configuration {
      variable(id: $variableId) {
        ...ConfigurationVariableFragment
      }
    }
  }
  ${CONFIGURATION_VARIABLE_FRAGMENT}
`;
